var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 24 24","width":"24","height":"24"}},[_c('path',{attrs:{"stroke":"#121212","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.8","d":"M5 7h14M18 7v11a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7M15 3.75H9M10 11v5M14 11v5"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }